import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Nav from "../../components/nav";
import {
  Flex,
  Title,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
} from "@tremor/react";
import Decoder from "./decoder";
import * as profileAPI from "../../services/profiles";
import { Cog6ToothIcon, CodeBracketIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import Config from "./config";
import SchemaTab from "./SchemaTab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIconFromName } from "../../components/IconPicker";

export default function ProfileSettings() {
  const { profileId } = useParams();
  const [profile, setProfile] = useState({});

  useEffect(() => {
    const getDevice = async () => {
      try {
        const data = await profileAPI.fetchOne(profileId);
        setProfile(data);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };
    getDevice();
  }, [profileId]);

  return (
    <div>
      <Nav />
      <main className="p-4 md:p-10 mx-auto max-w-7xl">
        <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm p-6 mb-6">
          <Flex justifyContent="between" className="items-center">
            <Flex justifyContent="start" className="space-x-4 items-center">
              <span className="profile-icon tremor-Icon-root inline-flex flex-shrink-0 items-center justify-center rounded-tremor-default bg-blue-500 text-white w-12 h-12">
                <FontAwesomeIcon
                  icon={getIconFromName(profile.image || "microchip")}
                  className="w-6 h-6"
                />
              </span>
              <div className="space-y-1">
                <Title className="text-2xl font-bold text-gray-900 dark:text-gray-50">
                  {profile.name || "Loading..."}
                </Title>
              </div>
            </Flex>
          </Flex>
        </div>

        <TabGroup className="mt-2" defaultIndex={0}>
          <TabList className="border-b border-gray-200 dark:border-gray-800">
            <Tab
              icon={TableCellsIcon}
              className="px-6 py-3 text-sm font-medium focus:outline-none"
            >
              Schema
            </Tab>
            <Tab
              icon={CodeBracketIcon}
              className="px-6 py-3 text-sm font-medium focus:outline-none"
            >
              Decoder
            </Tab>
            <Tab
              icon={Cog6ToothIcon}
              className="px-6 py-3 text-sm font-medium focus:outline-none"
            >
              Settings
            </Tab>
          </TabList>
          <TabPanels className="mt-4">
            <TabPanel>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-6">
                <SchemaTab profile={profile} onSaved={setProfile} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-6">
                <Decoder profile={profile} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-6">
                <Config profile={profile} />
              </div>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </main>
    </div>
  );
}
